import { BookingInfoPage } from './booking-info/booking-info.page';
import { CalendarSettingsPage } from './calendar-settings/calendar-settings.page';
import { VideoArchivesSettingsPage } from './video-archives-settings/video-archives-settings.page';
import { MusicSettingsPage } from './music-settings/music-settings.page';
import { SpecialsSettingsPage } from './specials-settings/specials-settings.page';
import { PlatformService } from './../../services/platform/platform.service';
import { GallerySettingsPage } from './gallery-settings/gallery-settings.page';
import { ContactInfoPage } from './contact-info/contact-info.page';
import { AccountInfoPage } from './account-info/account-info.page';
import { PrimaryInfoPage } from './primary-info/primary-info.page';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { IonAccordionGroup, ModalController } from '@ionic/angular';
import { ViewChild } from '@angular/core';
import { SubSink } from 'subsink';
import { IsUserLoggedInService } from 'src/app/services/user/is-user-logged-in.service';

@Component({
  selector: 'app-profile-settings',
  templateUrl: './profile-settings.page.html',
  styleUrls: ['./profile-settings.page.scss'],
})
export class ProfileSettingsPage implements OnInit {
  subscription = new SubSink();
  isMobileDevice: boolean;
  selectedStep: string | undefined;
  @ViewChild(IonAccordionGroup) group!: IonAccordionGroup;

  public isPackageActive: boolean = false;

  constructor(
    private auth: AuthService,
    private platform: PlatformService,
    private router: Router,
    private modalCtrl: ModalController,
    private loggedInService: IsUserLoggedInService
  ) {
    this.isMobileDevice = this.platform.isMobile();
  }

  ngOnInit() {
    console.log("settings oninit");
    this.subscription.sink = this.loggedInService._subscribeStatus.subscribe((value) => {
      this.isPackageActive = value;
    });
  }

  ionViewWillEnter() {
    this.group.value = undefined;
    this.selectedStep = undefined;
  }

  async openAccountInfoModal() {
    const modal = await this.modalCtrl.create({
      component: AccountInfoPage,
    });
    modal.present();
    await modal.onWillDismiss();
  }

  async openPrimaryInfoModal() {
    const modal = await this.modalCtrl.create({
      component: PrimaryInfoPage,
    });
    modal.present();
    await modal.onWillDismiss();
  }

  async openContactInfoModal() {
    const modal = await this.modalCtrl.create({
      component: ContactInfoPage,
    });
    modal.present();
    await modal.onWillDismiss();
  }

  async openGalleryInfoModal() {
    const modal = await this.modalCtrl.create({
      component: GallerySettingsPage,
    });
    modal.present();
    await modal.onWillDismiss();
  }

  async openSpecialsModal() {
    const modal = await this.modalCtrl.create({
      component: SpecialsSettingsPage,
    });
    modal.present();
    await modal.onWillDismiss();
  }

  async openMusicModal() {
    const modal = await this.modalCtrl.create({
      component: MusicSettingsPage,
    });
    modal.present();
    await modal.onWillDismiss();
  }

  async openVideoArchivesModal() {
    const modal = await this.modalCtrl.create({
      component: VideoArchivesSettingsPage,
    });
    modal.present();
    await modal.onWillDismiss();
  }

  async openCalendarModal() {
    const modal = await this.modalCtrl.create({
      component: CalendarSettingsPage,
    });
    modal.present();
    await modal.onWillDismiss();
  }

  async openBookingModal() {
    const modal = await this.modalCtrl.create({
      component: BookingInfoPage,
    });
    modal.present();
    await modal.onWillDismiss();
  }

  async logOut() {
    this.loggedInService.changeUserStatus(0);
    await this.auth.logout();
    this.router.navigate(['login']);
  }

  getSelected(event: any) {
    this.selectedStep = event.detail.value;
  }
}
